import { useTranslations, useLocale } from 'next-intl';
import cn from 'classnames';
import TicketIcon from 'assets/icons/ticket.svg';
import { Link } from 'src/navigation';
import { getEngageBaseUrl } from 'lib/engage';
import styles from './ticket-link.module.scss';
import type { ComponentProps } from 'react';

const TicketLink = ({
	variant = 'normal',
	navigationBuyTicketsCode,
	className,
	...props
}: TicketLinkProps) => {
	const t = useTranslations();
	const locale = useLocale();
	const isSmallVariant = variant === 'small';

	return (
		<Link
			prefetch={false}
			className={cn(
				'button',
				'primary',
				styles.ticketLink,
				{ [styles.small]: isSmallVariant },
				className,
			)}
			href={`${getEngageBaseUrl(locale)}/admission/?promocode=${navigationBuyTicketsCode ?? ''}`}
			{...props}
		>
			<span className={styles.ticketLabel}>
				<span className={styles.tickets}>
					<TicketIcon className={cn(styles.ticket, styles.ticket1)} />
					<TicketIcon className={cn(styles.ticket, styles.ticket2)} />
				</span>
				{isSmallVariant ? t('tickets') : t('buyTickets')}
			</span>
		</Link>
	);
};

export { TicketLink };

interface TicketLinkProps extends Omit<ComponentProps<typeof Link>, 'href'> {
	variant?: 'normal' | 'small';
	navigationBuyTicketsCode?: number | string;
	className?: string;
}
